// SHARED-009: Phaser game initialization
import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';

let gameInstance: Phaser.Game | null = null;

/** Device pixel ratio clamped to max 2, for HiDPI canvas & text rendering */
export const GAME_DPR = Math.min(window.devicePixelRatio || 1, 2);

/** Logical game dimensions (design coordinates) — camera zoom maps these to the high-res canvas */
export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

export function createGame(parent: string | HTMLElement): Phaser.Game {
  if (gameInstance) return gameInstance;

  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent,
    width: Math.round(GAME_WIDTH * GAME_DPR),
    height: Math.round(GAME_HEIGHT * GAME_DPR),
    backgroundColor: '#171613',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, PreloadScene],
    physics: {
      default: 'arcade',
      arcade: { debug: false },
    },
    render: {
      antialias: true,
      roundPixels: true,
    },
  };

  gameInstance = new Phaser.Game(config);
  return gameInstance;
}

export function getGame(): Phaser.Game | null {
  return gameInstance;
}

export function destroyGame(): void {
  if (gameInstance) {
    gameInstance.destroy(true);
    gameInstance = null;
  }
}

/** Register additional scenes (called by phases) */
export function registerScene(key: string, scene: typeof Phaser.Scene): void {
  if (gameInstance && !gameInstance.scene.getScene(key)) {
    gameInstance.scene.add(key, scene);
  }
}
